
import { useIntl } from "@hlcr/ui/Intl";
import React from "react";

import styles from "bugBounty/components/reportedBugsTable.module.scss";
import CustomInput from "components/CustomInput/CustomInput";


const ReportedBugTableFilterInput = ({ onFilterInputChange }: { onFilterInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void }) => {
	const intl = useIntl();
	return (<div className={styles.filters}>
		<CustomInput
			inputProps={{
				type: "inputSearch",
				onChange: onFilterInputChange,
				placeholder: intl.fm("common.labels.filter"),
			}}
		/>
	</div>);
};

export default ReportedBugTableFilterInput;
